module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMove($event)
      },
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((24), function(h) {
    return _c('div', {
      staticClass: "ds-hour",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addAt(h)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.day.events), function(event, i) {
    return [(_vm.isVisible(event)) ? _c('ds-calendar-event-time', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "calendar": _vm.calendar
      }
    }, 'ds-calendar-event-time', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners)) : _vm._e()]
  }), _vm._v(" "), (_vm.day.currentDay) ? _c('div', {
    style: (_vm.nowLine)
  }) : _vm._e(), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-time-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar
    }
  }, 'ds-calendar-event-time-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74cb2e5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayTimes.vue
// module id = 420
// module chunks = 1